import { WritableSignal, computed, signal } from "@angular/core";
import { IInstallationMenuItem, IInstallationParentFlat } from "../../../../services/api-services/installations/response/installation-menu-item.response";
import { InstallationType } from "../../../../services/api-services/installations/types/installation-type.type";


export class InstallationMenuItemNew implements IInstallationMenuItem {
  installationId?: number;
  groupId?: number;
  refCode: string;
  urlPrefix?: string;
  name: string;
  isEnabled?: boolean;
  /** Being moved to another server: locked, dashboard only (IInstallationMenuItem.isBeingMoved). */
  isBeingMoved?: boolean;
  /** License expired: closed, only the license expired page (IInstallationMenuItem.isSuspended). */
  isSuspended?: boolean;
  licenseExpiry?: string | null;
  hasOtherInstallations?: boolean | null;
  installationGroup?: number;
  alias?: string;
  address?: string;
  postalCode?: string;
  city?: string;
  country?: string;
  phone?: string;
  contactPerson?: string;
  contactEmail?: string;
  type: InstallationType;
  parentRefCode?: string | null;
  parentMenuRef?: InstallationMenuItemNew | undefined;
  parent?: IInstallationParentFlat | undefined;
  parentsFlat?: IInstallationParentFlat[]; // Not comming from backend, should be done manual;
  children?: InstallationMenuItemNew[] | undefined; // This should be mapped and have the correct ref here


  isCollapsed: WritableSignal<boolean> = signal(true);

  iconName = computed(() => {
    switch (this.type) {
      case 'installation':
        return 'roofing'
      case 'subInstallation':
        return 'apartment'
      case 'topGroup':
        return 'grain'
      case 'group':
        return 'account_tree'
      default:
        return 'roofing';
    }
  })

  iconClassName = computed(() => {
    switch (this.type) {
      case 'installation':
        return 'text-insta-installation'
      case 'subInstallation':
        return 'text-insta-sub-installation'
      case 'topGroup':
        return 'text-insta-top-group'
      case 'group':
        return 'text-insta-group'
      default:
        return 'text-insta-intallation';
    }
  })

  constructor() {
  }

  public setChildsToCollapsed(installation: InstallationMenuItemNew = this) {
    installation.isCollapsed.set(true);
    if (!installation.children || installation.children?.length === 0) return;
    installation.children.forEach((child) => {
      this.setChildsToCollapsed(child);
    });
  }

  public checkExpandedChilds(installation: InstallationMenuItemNew = this): number {
    if (installation.isCollapsed()) return 0;
    if (!installation.children || installation.children?.length === 0) return 0;

    let childs = 0;
    installation.children.forEach((childInstallation) => {
      childs = Math.max(this.checkExpandedChilds(childInstallation), childs);
    });

    return childs + 1;
  }
}